import produce from "immer";
import { EmailSequencesActions } from ".";
import { IStoreState } from "../initialStoreState";
import {
  initialEmailSequencesState,
  initialSequence,
} from "./emailSequences.types";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_EMAIL_SEQUENCE,
  CLEAR_EMAIL_SEQUENCES_STATE,
  FETCH_RECORD_SEQUENCES_FAILED,
  FETCH_RECORD_SEQUENCES_PROGRESS,
  FETCH_RECORD_SEQUENCES_SUCCESS,
  FETCH_SEQUENCE_ENROLMENTS_FAILED,
  FETCH_SEQUENCE_ENROLMENTS_PROGRESS,
  FETCH_SEQUENCE_ENROLMENTS_SUCCESS,
  FETCH_SEQUENCE_FAILED,
  FETCH_SEQUENCE_LIST_FAILED,
  FETCH_SEQUENCE_LIST_PROGRESS,
  FETCH_SEQUENCE_LIST_SUCCESS,
  FETCH_SEQUENCE_PROGRESS,
  FETCH_SEQUENCE_STATS_FAILED,
  FETCH_SEQUENCE_STATS_PROGRESS,
  FETCH_SEQUENCE_STATS_SUCCESS,
  FETCH_SEQUENCE_SUCCESS,
  FETCH_UPCOMING_FAILED,
  FETCH_UPCOMING_PROGRESS,
  FETCH_UPCOMING_SUCCESS,
} from "./emailSequencesActions";

export const emailSequencesReducer = (
  state: IStoreState["emailSequences"] = initialEmailSequencesState,
  action: EmailSequencesActions
) => {
  switch (action.type) {
    // ---- List -------------------------------------------------------------
    case FETCH_SEQUENCE_LIST_PROGRESS:
      return produce(state, (draft) => {
        draft.listLoading = LoadState.InProgress;
        draft.list = [];
      });
    case FETCH_SEQUENCE_LIST_SUCCESS:
      return produce(state, (draft) => {
        draft.listLoading = LoadState.Loaded;
        draft.list = action.payload.data;
        draft.totalRecords = action.payload.totalRecords;
      });
    case FETCH_SEQUENCE_LIST_FAILED:
      return produce(state, (draft) => {
        draft.listLoading = LoadState.Failed;
        draft.list = [];
      });

    // ---- Single sequence --------------------------------------------------
    case FETCH_SEQUENCE_PROGRESS:
      return produce(state, (draft) => {
        draft.sequenceLoading = LoadState.InProgress;
      });
    case FETCH_SEQUENCE_SUCCESS:
      return produce(state, (draft) => {
        draft.sequenceLoading = LoadState.Loaded;
        draft.sequence = action.payload.data;
      });
    case FETCH_SEQUENCE_FAILED:
      return produce(state, (draft) => {
        draft.sequenceLoading = LoadState.Failed;
      });

    // ---- Stats ------------------------------------------------------------
    case FETCH_SEQUENCE_STATS_PROGRESS:
      return produce(state, (draft) => {
        draft.statsLoading = LoadState.InProgress;
        draft.stats = null;
      });
    case FETCH_SEQUENCE_STATS_SUCCESS:
      return produce(state, (draft) => {
        draft.statsLoading = LoadState.Loaded;
        draft.stats = action.payload.data;
      });
    case FETCH_SEQUENCE_STATS_FAILED:
      return produce(state, (draft) => {
        draft.statsLoading = LoadState.Failed;
        draft.stats = null;
      });

    // ---- Enrolments -------------------------------------------------------
    case FETCH_SEQUENCE_ENROLMENTS_PROGRESS:
      return produce(state, (draft) => {
        draft.enrolmentsLoading = LoadState.InProgress;
        draft.enrolments = [];
      });
    case FETCH_SEQUENCE_ENROLMENTS_SUCCESS:
      return produce(state, (draft) => {
        draft.enrolmentsLoading = LoadState.Loaded;
        draft.enrolments = action.payload.data;
        draft.enrolmentsTotalRecords = action.payload.totalRecords;
      });
    case FETCH_SEQUENCE_ENROLMENTS_FAILED:
      return produce(state, (draft) => {
        draft.enrolmentsLoading = LoadState.Failed;
        draft.enrolments = [];
      });

    // ---- Record sequences -------------------------------------------------
    case FETCH_RECORD_SEQUENCES_PROGRESS:
      return produce(state, (draft) => {
        draft.recordSequencesLoading = LoadState.InProgress;
        draft.recordSequences = [];
      });
    case FETCH_RECORD_SEQUENCES_SUCCESS:
      return produce(state, (draft) => {
        draft.recordSequencesLoading = LoadState.Loaded;
        draft.recordSequences = action.payload.data;
      });
    case FETCH_RECORD_SEQUENCES_FAILED:
      return produce(state, (draft) => {
        draft.recordSequencesLoading = LoadState.Failed;
        draft.recordSequences = [];
      });

    // ---- Upcoming ---------------------------------------------------------
    case FETCH_UPCOMING_PROGRESS:
      return produce(state, (draft) => {
        draft.upcomingLoading = LoadState.InProgress;
        draft.upcoming = [];
      });
    case FETCH_UPCOMING_SUCCESS:
      return produce(state, (draft) => {
        draft.upcomingLoading = LoadState.Loaded;
        draft.upcoming = action.payload.data;
        draft.upcomingTotalRecords = action.payload.totalRecords;
      });
    case FETCH_UPCOMING_FAILED:
      return produce(state, (draft) => {
        draft.upcomingLoading = LoadState.Failed;
        draft.upcoming = [];
      });

    // ---- Clear ------------------------------------------------------------
    case CLEAR_EMAIL_SEQUENCE:
      return produce(state, (draft) => {
        draft.sequence = initialSequence;
        draft.sequenceLoading = LoadState.NotLoaded;
        draft.stats = null;
        draft.statsLoading = LoadState.NotLoaded;
        draft.enrolments = [];
        draft.enrolmentsLoading = LoadState.NotLoaded;
      });
    case CLEAR_EMAIL_SEQUENCES_STATE:
      return initialEmailSequencesState;

    default:
      return state;
  }
};
